import { Link } from 'react-router-dom';

import { trackSearchResultClicked } from '@/analytics/events';

type CTAVariant = 'dropdown-empty' | 'dropdown-footer' | 'page-empty' | 'page-footer';

interface CantFindItCTAProps {
  query: string;
  variant: CTAVariant;
  // The search attempt this CTA belongs to (#448), so the `request` click
  // joins the same funnel as the search that surfaced it.
  searchId: string;
}

const variantStyles: Record<CTAVariant, string> = {
  'dropdown-empty': 'mt-2 text-center',
  'dropdown-footer': 'mt-2 text-left',
  'page-empty': 'mt-4 text-center',
  'page-footer': 'mt-0 text-center',
};

export function CantFindItCTA({ query, variant, searchId }: CantFindItCTAProps) {
  // Link-first request (RFC 016): the old self-serve create form is gone; the
  // search miss is the single way in, for coffees and roasters alike. The
  // search term rides along to seed the name fallback.
  const requestUrl = `/request${query ? `?name=${encodeURIComponent(query)}` : ''}`;
  // The variant prefix encodes which surface this CTA renders on.
  const surface = variant.startsWith('dropdown') ? 'dropdown' : 'results_page';

  return (
    <div className={variantStyles[variant]} data-testid="cant-find-it-cta">
      <p className="m-0 text-sm text-black/60">
        Can&apos;t find what you&apos;re looking for?{' '}
        <Link
          to={requestUrl}
          className="font-bold text-wolisho-red hover:underline"
          onClick={() =>
            trackSearchResultClicked({ query, surface, target: 'request', search_id: searchId })
          }
        >
          Request with a link
        </Link>
      </p>
    </div>
  );
}
